import JobWorkerOfferWorkerDeclinedReason from "@/models/JobWorkerOffers/JobWorkerOfferWorkerDeclinedReason";

export default (value: JobWorkerOfferWorkerDeclinedReason) => {
    switch (value) {
        case JobWorkerOfferWorkerDeclinedReason.Salary:
            return "Salary is too low";
        case JobWorkerOfferWorkerDeclinedReason.FoundAnotherJob:
            return "Found another job";
        case JobWorkerOfferWorkerDeclinedReason.CounterOffer:
            return "Counter offer made by current employer";
        case JobWorkerOfferWorkerDeclinedReason.NoLongerLooking:
            return "No longer looking";
        default:
            return "Unknown";
    }
} 